import { render, staticRenderFns } from "./UpsertPermissionV2.vue?vue&type=template&id=5d25a8cc"
import script from "./UpsertPermissionV2.vue?vue&type=script&lang=js"
export * from "./UpsertPermissionV2.vue?vue&type=script&lang=js"
import style0 from "./UpsertPermissionV2.vue?vue&type=style&index=0&id=5d25a8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports